export class DconfigCoreSettings {
  public static API_ENDPOINT = 'http://dconfig.com';

  public static setEndPoint(value) {
    this.API_ENDPOINT = value;
  }
}
